import { PASSAGES_SHORT_SUCCESS } from '../../actions/passages/short';

const defaultState = {
  result: null,
};

export default function reducer(state = defaultState, action) {
  if (action.type === PASSAGES_SHORT_SUCCESS) {
    return { ...action.payload };
  }

  return state;
}
